import React, { useEffect, useReducer, useState } from "react";
import BsModal from "../../Common/BsModal";
import Notification from "../../Common/Notification";
import { useAccounts } from "../../../DataStore/AccountsContext";
import ajaxSchool from "../../../util/remote/ajaxSchool";
import TextInput from "../../Common/TextInput";

const reducer = (state, action) => {
  if (action.type === "RESET") return { ...initialState };
  return { ...state, [action.type]: action.value };
};
const initialState = {
  loading: false,

  amount:'',
  paymentAccount:'',
  transactionDate:'',
  reference:'',
  description:'',
  isOpeningBalance: false,
};

const StudentAdvanceModal = ({
  show,
  onClose,
  studentId,
  student
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [currentNotify, setNotify] = useState(null);
  const {paymentAccountListing, getPaymentAccounts} = useAccounts();


  useEffect(() => {
    if (show) {
      getPaymentAccounts();
      //Automatically set description
      dispatch({type: 'description', value: `Advance fees payment for ${student?.first_name} ${student?.last_name}`});
    } else {
      setNotify(null);
    }
  }, [show]);



  const requireField = (condition, message) => {
    if (condition) {
      setNotify(<Notification type="danger" message={message} />);
      return true;
    }
    return false;
  };

  const RenderPaymentAccount = () => {
              
        const options=[];
        if(Array.isArray(paymentAccountListing))
        {
            paymentAccountListing.map((item, key)=>
                options.push({label:item.account_number + ' ' + item.account_name, value:item.account_id})
            )
        }
        return(
            <TextInput
                type="select"
                label="Destination Account"
                placeholder="Select Account"
                leftIcon="fa fa-bank"
                options={options}
                onChange={(item)=>dispatch({type: 'paymentAccount', value: item?.value})}
                leftComponent={<i className="fa fa-bank link" onClick={()=>getPaymentAccounts(true)}></i>}
                loading={!paymentAccountListing}
                required
                wrap
                value={state.paymentAccount}
        />

        )
    }

  const handleSave = async () => {
    if (state.loading) return;
    if (requireField(!String(state.amount || "").trim(), "Enter Amount.")) return;
    if (requireField(!String(state.paymentAccount || "").trim(), "Enter a payment account.")) return;



    dispatch({ type: "loading", value: true });

    const payload = {
    
        student_id: studentId,
        amount: state.amount,
        payment_account: state.paymentAccount,
        transaction_date: state.transactionDate,
        reference: state.reference,
        description: state.description,
        is_opening_balance: state.isOpeningBalance ? 1 : 0,
        tag: '0'
    }

    dispatch({ type: 'loading', value: true });
   const server_response = await ajaxSchool.postStudentAdvance(payload);
    dispatch({ type: 'loading', value: false });

    if (server_response.status === 'OK') {
        setNotify(<Notification type="success" message={server_response.message} />);
        //reset form
        dispatch({type: 'RESET'});
    } else {
        setNotify(<Notification type="danger" message={server_response.message} />);
    }
  };

  
  return (
    <BsModal
      show={show}
      onClose={onClose}
      title="Add Student Fees Advance"
      size="modal-lg"
      footer={
         <>
            <button type="button" className="btn btn-modern-secondary" onClick={onClose} disabled={state.loading}>
              Close
            </button>

          <button type="button" className="btn btn-modern-primary" onClick={handleSave} disabled={state.loading}>
            {state.loading ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" />
                Saving...
              </>
            ) : (
              <>
                <i className="fa fa-check-circle mr-2"></i> Post Advance
              </>
            )}
          </button>
        </>
      }
    >
    
      {currentNotify}

      <div className="row">
        <div className="col-md-6">
           <TextInput
            type="date"
            label="Transaction Date"
            placeholder="Transaction Date"
            leftIcon="fa fa-calendar-alt"
            value={state.transactionDate}
            onChange={e => dispatch({type: 'transactionDate', value: e.target.value})}
            wrap
            required
            />
          
        </div>

        <div className="col-md-6">
          <RenderPaymentAccount />
        </div>
      </div>
       <div className="row">
        <div className="col-md-6">
          <TextInput
              type="text"
              label="Amount"
              placeholder="Amount"
              leftIcon="fa fa-credit-card"
              value={state.amount}
              onChange={e => dispatch({type: 'amount', value: e.target.value})}
              wrap
              required
              />
        </div>
        <div className="col-md-6">
           <TextInput
              type="text"
              label="Reference"
              placeholder="Payment reference"
              leftIcon="fa fa-hashtag"
              value={state.reference}
              onChange={e => dispatch({type: 'reference', value: e.target.value})}
              wrap
              required
              />
        </div>
        
      </div>
      <div className="row">
        <div className="col-md-12">
           <TextInput
              type="textarea"
              label="Description"
              placeholder="Description"
              leftIcon="fa fa-info-circle"
              value={state.description}
              onChange={e => dispatch({type: 'description', value: e.target.value})}
              wrap
              required
              />
        </div>
      </div>

     
      <div
             className="p-3 mt-2 mb-3"
             style={{
               borderRadius: 12,
               border: "1px solid rgba(255,255,255,0.08)",
               background: "rgba(255,255,255,0.02)",
             }}
           >
             <div className="d-flex align-items-center justify-content-between">
               <div className="font-weight-bold">
                 <i className="fa fa-cogs text-primary mr-2" />
                 Migration Assistant
               </div>
     
               <div className="custom-control custom-switch">
                 <input
                   type="checkbox"
                   className="custom-control-input"
                   id="isOpeningBalanceSwitch"
                   checked={state.isOpeningBalance}
                   onChange={(e) => dispatch({ type: "isOpeningBalance", value: e.target.checked })}
                 />
                 <label className="custom-control-label" htmlFor="isOpeningBalanceSwitch">
                   Opening Balance
                 </label>
               </div>
             </div>
     
             <div className="text-muted mt-1" style={{ fontSize: 13 }}>
               Turn on “Opening Balance” if this advance is being carried over from a previous accounting system. This will set the transaction date to the start of the current Billing Batch.
             </div>
     
           
           </div>
      

      {/* helper: show guideline if user is in Assets or chose parent Bank, even if they didn't click "tips" */}
    </BsModal>
  );
};


export default StudentAdvanceModal;
